import { render, staticRenderFns } from "./BlockListStructuredDataCustom.vue?vue&type=template&id=bb0b984e&"
import script from "./BlockListStructuredDataCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListStructuredDataCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports